import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})
export class ConfirmationPopupComponent implements OnInit {

  @Input() details: any = {
    message: '',
    message1: '',
    title: '',
    action: 'Yes, Delete it!'
  };
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit(): void {
  }

  Cancel() {
    this.close.emit()
  }

  confirm() {
    this.close.emit(true);
  }

}
